import { getCookie } from '@/src/utils/browser'
import { isNxItineraryId } from '../itinerary/isNxItineraryId'

const ITINEX_PREFIX = '/bff/orbit/v1'

export const getItineraryEndpointPath = (itineraryId: string, path: string) => {
    const isNxId = isNxItineraryId(itineraryId)
    return isNxId ? `${ITINEX_PREFIX}${path}` : path
}

export const getCreateItineraryEndpointPath = (path: string) => {
    const shouldUseItinexPrefix =
        typeof window !== 'undefined' && getCookie('itinex') === 'true'

    return shouldUseItinexPrefix ? `${ITINEX_PREFIX}${path}` : path
}

export default getItineraryEndpointPath
